"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Array2D = void 0;
var utils_1 = require("../utils");
exports.Array2D = {
  /** Get the value at column `x`, row `y` */
  get: function (data, x, y) {
    if (x < 0 || x >= data.nColumns || y < 0 || y >= data.nRows) {
      return undefined;
    }
    return data.values[data.nColumns * y + x];
  },
  /** Return an Array2D with dimensions 0x0 with no data. */
  empty: function () {
    return {
      nColumns: 0,
      nRows: 0,
      values: [],
      isNumeric: true
    };
  },
  /** Return an Array2D with dimensions nColumns x nRows. */
  create: function (nColumns, nRows, values) {
    if (values.length !== nColumns * nRows) throw new Error('ValueError: length of `values` must be nColumns * nRows');
    var isNumeric = (0, utils_1.isNumericArray)(values);
    return {
      nColumns: nColumns,
      nRows: nRows,
      values: values,
      isNumeric: isNumeric
    };
  },
  /** Return new `Data` with random values between 0 and 1 */
  createRandom: function (nColumns, nRows) {
    var n = nColumns * nRows;
    var values = new Float32Array(n);
    for (var i = 0; i < n; i++) {
      values[i] = Math.random();
    }
    return {
      nColumns: nColumns,
      nRows: nRows,
      values: values,
      isNumeric: true
    };
  },
  /** Return new `Data` with partly random value having a gradient from left to right, and special values around the edges */
  createDummy: function (nColumns, nRows) {
    var n = nColumns * nRows;
    var values = new Float32Array(n);
    for (var i = 0; i < n; i++) {
      var x = i % nColumns;
      var y = Math.floor(i / nColumns);
      var val = x === 0 || y === nRows - 1 ? 0 : x === nColumns - 1 || y === 0 ? 1 : Math.random();
      values[i] = 0.5 * val + 0.5 * (i % nColumns / nColumns);
    }
    return {
      nColumns: nColumns,
      nRows: nRows,
      values: values,
      isNumeric: true
    };
  },
  /** Return minimum and maximum value in the data */
  getRange: function (data) {
    var values = data.values;
    var n = values.length;
    var min = Infinity;
    var max = -Infinity;
    for (var i = 0; i < n; i++) {
      var d = values[i];
      if (d < min) min = d;
      if (d > max) max = d;
    }
    return {
      min: min,
      max: max
    };
  },
  /** Throw error if the length of array does not match size given by `nColumns` and `nRows` */
  validateLength: function (data) {
    if (data.values.length !== data.nColumns * data.nRows) {
      throw new Error('ValueError: length of data.values must be data.nColumns * data.nRows');
    }
  }
};